import React, { useState, useRef, useEffect } from 'react';
import styles from './OTP.module.css'; 
import { useNavigate, useLocation } from 'react-router-dom'; 
import Footer from '../Footer/Footer'
import { useTranslation } from "react-i18next";
import notify from '../Utilities/notify';
import { useDispatch, useSelector} from "react-redux";
import Spinner from 'react-bootstrap/Spinner';
import { getVerificationCode , editUser, register } from '../../redux/Slices/users/thunk';

const OTP = () => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language; 
  const [otp, setOtp] = useState(['', '', '','']);
  const navigate = useNavigate(); 
  const location = useLocation();
  const dispatch = useDispatch();
  const [time, setTime] = useState(180); // 3 minutes in seconds
  const [isResendDisabled, setIsResendDisabled] = useState(true); // To disable resend button
  const {oneUser, loading, verificationCode} = useSelector((state) => state.usersSlice);
  const user = JSON.parse(localStorage.getItem('user'))
  const [isLoading,setIsLoading] = useState(false)


console.log("oneUser",oneUser)
  const inputRefs = useRef([]);
  const loginResponse = location?.state?.res || null;
  const registerData = location?.state?.data || null;
  

  console.log("loginResponse",loginResponse)


  console.log("verificationCode",verificationCode)
  useEffect(() => {
    if (time === 0) {
      setIsResendDisabled(false); // Disable resend when time is up
      return;
    }

    const timerId = setInterval(() => {
      if (time > 0) {
        setTime((prevTime) => prevTime - 1);
      }
    }, 1000);

    return () => clearInterval(timerId); // Cleanup timer when the component is unmounted
  }, [time]);

  if(!loginResponse){
    return navigate('/login')
  }


  const handleChange = (index, value) => {
    if (/^\d?$/.test(value)) { // Allow only a single digit
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input field
      if (value && index < 3) {
        inputRefs.current[index + 1]?.focus();
      }

    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    if (e.key === 'Enter') {
      // Trigger onSubmit when Enter is pressed
      onSubmit();
    }
  };

  const handleNavigateToLogin = () => {
    console.log("mmm")
    // localStorage.clear();
    return  navigate('/login');
  };


    // Format the time into mm:ss
    const formatTime = (time) => {
      const minutes = String(Math.floor(time / 60)).padStart(2, '0');
      const seconds = String(time % 60).padStart(2, '0');
      return `${minutes}:${seconds}`;
    };


    const handleResendClick = async () => {
      if(isResendDisabled == false){
        setTime(10);
        setIsResendDisabled(true); // Disable resend button again
        await dispatch(getVerificationCode())
      }
      else return
    };
let code
if(verificationCode){
  code = verificationCode?.verifyCode
}
else{
  code = loginResponse?.verificationCode
}
const result = [
  code[1], 
  code[3], 
  code[5],
  code[7]  
];
const finalString = result.join(''); 
console.log(finalString);


    const onSubmit = async ()=>{
      console.log("registerData",registerData)
      setIsLoading(true)
      if (otp.some((value) => value === "")) {
        notify(t("OTPIsIncomplete"), "error");
        return;
      }
      let data={
        cln_isverificated:1
      }
      console.log("OTP Submitted:", otp.join(''));
      if(otp.join('') == finalString){
        if(registerData){
        const response =  await dispatch(register({data:registerData}))
        console.log("response",response)
         localStorage.setItem('user', JSON.stringify(response.payload));

        }else{
          await dispatch(editUser({id:loginResponse?.cln_key, data}))
          const updatedUser = {
            ...user,
            cln_isverificated: "1",
          };
          localStorage.setItem('user', JSON.stringify(updatedUser));
        }
        setIsLoading(false)
        return navigate('/branches')
      }
      else {  
        setIsLoading(false)
        notify(t("OTPIsn'tCorrect"), "error");
      }
     

    }
  return (
    <div>
    <div  className={styles.mainContainer} >
      <div  className={styles.enterOtpLapel} >{t("EnterTheSentNumber")}</div>
      <div  className={styles.mobileNumberContainer} >
      {currentLanguage =="ar" ?   
      <div className={styles.mobileNumber}><span>{registerData ? registerData?.mobile :user?.cln_mobl}</span>+</div> :
      <div className={styles.mobileNumber}>+<span>{registerData ? registerData?.mobile :user?.cln_mobl}</span></div> 
    }
        <div className={styles.editNumber} onClick={handleNavigateToLogin}>{t("EditNumber")}</div>
         </div>
 <div className={styles.otpContainer}>
      {otp.map((digit, index) => (
        <input
          key={index}
          ref={(el) => (inputRefs.current[index] = el)}
          type="text"
          maxLength="1"
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          className={styles.otpInput}
          inputMode="numeric" // Opens number keyboard on mobile/tablet
          pattern="[0-9]*" 
        />
      ))}
    </div>

    <div  className={styles.mobileNumberContainer} >
        <div className={styles.mobileNumber}>{formatTime(time)} </div>
        <div className={styles.editNumber} disabled={isResendDisabled}   style={{cursor: isResendDisabled ? 'not-allowed' : 'pointer', }} onClick={handleResendClick} >{t("SendAgain")}</div>
         </div>
         <div className={styles.onSubmit} onClick={onSubmit} >{isLoading ? <Spinner />  : t("send")}</div>
         {false && <h1 style={{color:"#B49345", margin:"auto", letterSpacing:"10px"}}>{finalString}</h1>}


    </div>
    {/* <div  className={styles.footerContainer} style={{marginTop:"20px", bottom:"0"}}>
      <Footer />
      </div> */}
    </div>
   
  );
};

export default OTP;
